import queryString from 'query-string';
import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchStorePages({ dispatch }, filters) {
  const queryParams = queryString.stringify(filters);

  return http.get(`${MINERVA_API_URL}/store-pages?${queryParams}`)
    .then((res) => {
      if (!filters.offset) {
        return dispatch('setStorePagesInStore', res.data);
      }

      return dispatch('addStorePagesInStore', res.data);
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching store pages:', err);
      return Promise.reject(err);
    });
}

export function setStorePagesInStore({ commit }, pageList) {
  commit(types.SET_PAGES, pageList);

  return Promise.resolve(pageList);
}

export function addStorePagesInStore({ commit }, pageList) {
  commit(types.ADD_PAGES, pageList);

  return Promise.resolve(pageList);
}

export function setSelectedStorePageId({ commit }, pageId) {
  commit(types.SET_SELECTED, pageId);

  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/app/store-pages/store/actions.js